var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_html.js